module.exports = require('../build/addons/MomentLocaleUtils');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-day-picker/moment/index.js
 ** module id = 3274
 ** module chunks = 0
 **/